import { TUser } from '../../types/user';

export const USER_DEFAULT = {
  isAuthenticated: false,
} as TUser;
